// src/Components/common/login/AuthGate.jsx
import { useEffect, useState } from "react";
import {
  fetchAuthSession,
  getCurrentUser,
  signInWithRedirect,
} from "aws-amplify/auth";

function hideBootSplash() {
  const el = document.getElementById("boot-splash");
  if (el) el.style.display = "none";
}
function setAuthCookie() {
  const isHttps =
    typeof window !== "undefined" && window.location.protocol === "https:";
  const base = "er_auth=1; Path=/; Max-Age=5184000; SameSite=Lax";
  document.cookie = isHttps ? `${base}; Secure` : base;
}
function stripAuthParamsFromUrl() {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (url.searchParams.has("code") || url.searchParams.has("state")) {
    url.searchParams.delete("code");
    url.searchParams.delete("state");
    window.history.replaceState({}, "", url.pathname + url.search);
  }
}

export default function AuthGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" ||
        (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap")) {
      return;
    }

    (async () => {
      try {
        const hasOAuthCode =
          typeof window !== "undefined" &&
          window.location.search.includes("code=");

        const tryGetSession = async (attempts = 3) => {
          for (let i = 0; i < attempts; i++) {
            const session = await fetchAuthSession().catch(() => null);
            const hasId = !!session?.tokens?.idToken;
            if (hasId) return true;
            await new Promise((r) => setTimeout(r, 200));
          }
          return false;
        };

        if (hasOAuthCode) {
          const ok = await tryGetSession(5);
          if (ok) {
            await getCurrentUser().catch(() => {});
            setAuthCookie();
            stripAuthParamsFromUrl();
            hideBootSplash();
            setReady(true);
            return;
          }
          await signInWithRedirect();
          return;
        }

        const ok = await tryGetSession(2);
        if (ok) {
          await getCurrentUser().catch(() => {});
          setAuthCookie();
          hideBootSplash();
          setReady(true);
          return;
        }

        await getCurrentUser()
          .then(() => {
            setAuthCookie();
            hideBootSplash();
            setReady(true);
          })
          .catch(async () => {
            await signInWithRedirect();
          });
      } catch {
        await signInWithRedirect();
      }
    })();
  }, []);

  // ⛔ Don't render anything in SSR or during react-snap to avoid pre-rendered HTML
  if (typeof window === "undefined") return null;
  if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") {
    return null;
  }

  // Keep the splash until the session is ready
  if (!ready) return null;

  return children;
}
